import type { HTMLAttributes, Ref } from 'react'

import { Flex, Tag, Text } from '@vtex/shoreline'
import classNames from 'classnames'

import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import {
  formatInsertionOrderDate,
  formatInsertionOrderValue,
  isDocumentStatusPending
} from './helpers'

import styles from './styles.module.css'

type OptionProps = {
  data: LinkInsertionOrderOption
  isDisabled?: boolean
  isFocused?: boolean
  isSelected?: boolean
  innerProps?: HTMLAttributes<HTMLDivElement>
  innerRef?: Ref<HTMLDivElement>
}

export const LinkInsertionOrderOptionRow = ({
  data,
  isFocused,
  innerProps,
  innerRef
}: OptionProps) => {
  const { t } = useAPPTranslation()
  const { data: insertionOrder } = data
  const meta = [
    insertionOrder?.sequential_id ? String(insertionOrder?.sequential_id) : '-',
    formatInsertionOrderValue({
      totalValue: insertionOrder?.total_value,
      currency: insertionOrder?.currency
    }),
    `${formatInsertionOrderDate(insertionOrder?.start_at)} – ${formatInsertionOrderDate(insertionOrder?.end_at)}`
  ].join(' · ')
  const showPendingBadge = isDocumentStatusPending(
    insertionOrder?.document_status
  )

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={classNames(styles.option, {
        [styles.optionFocused]: isFocused
      })}
      data-testid={`link-io-option-${insertionOrder?.id}`}
    >
      <Flex align="center" gap="$space-2">
        <Text as="div" variant="emphasis">
          {insertionOrder?.name}
        </Text>
        {showPendingBadge ? (
          <Tag
            color="yellow"
            variant="secondary"
            data-testid={`link-io-document-status-pending-${insertionOrder?.id}`}
          >
            {t('rm:campaign.insertionOrder.documentStatus.pending')}
          </Tag>
        ) : null}
      </Flex>
      <Text as="div" variant="caption1" color="var(--sl-fg-base-soft)">
        {meta}
      </Text>
    </div>
  )
}
